import { reduxForm } from 'redux-form';
import { QueuesTeamsTable as QueuesTeamsTableImpl, } from '../components/queuesTeamsTable';
const FORM_NAME = 'queuesTeamsTableForm';
const QueuesTeamsTableForm = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
})(QueuesTeamsTableImpl);
export { QueuesTeamsTableForm as QueuesTeamsTable };
